const getVariation = (variations, value) => {
  return variations.find(varAttr => (varAttr == null ? void 0 : varAttr.value) === value);
};

export default getVariation;